// extracted by mini-css-extract-plugin
export default {"root":"Email_root__HfAXe","header":"Email_header__d-j+a","body":"Email_body__fjnNL"};